export function sanitizeCouponCode(couponCode?: string): string {
  if (!couponCode) {
    return '';
  }

  const match = /\w+/.exec(couponCode.substring(0, 100));
  return match ? match[0] : '';
}
